import { withChartLayout } from 'components/common';
import NeurologicalAssessment from 'components/features/chart/system-assessment/neurological-assessment/NeurologicalAssessment';

const NeurologicalAssessmentPage = withChartLayout('Neurological Assessment')(NeurologicalAssessment);
export default NeurologicalAssessmentPage;
